import { Link } from 'react-router-dom';
import { events } from '@/mocks/events';
import EventCard from '@/components/feature/EventCard';

export default function EvidenceGrid() {
  const picks = [events[1], events[3], events[6], events[2], events[7], events[4]];

  return (
    <section className="bg-background-100/60 border-y border-background-200/70">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-3">
          <div>
            <p className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
              <span className="inline-block w-8 border-t-2 border-primary-500"></span>证据索引
            </p>
            <h2 className="mt-3 font-display font-black text-foreground-950 text-2xl md:text-3xl">
              精选事件档案
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md md:text-right">
            每张卡片代表一份独立事件档案，内附素材清单、来源说明与完整时间线。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {picks.map((ev) => (
            <EventCard key={ev.slug} ev={ev} />
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/archive"
            className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 border border-primary-200 hover:bg-primary-100 rounded-full px-6 py-2.5 text-sm font-medium transition-colors"
          >
            浏览全部档案 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}